import React, { Component } from 'react';
import { connect }                from 'react-redux';

class Navbar extends Component {

  render() {
    return (
        <nav>
          <div className="nav-wrapper">
            <a className="desktop-logo brand-logo center hide-on-small-only">AlphaScrip</a>
            <ul id="nav-mobile" className="left">
              <li><a onClick={e => {this.props.history.push('/dashboard')}}>Home</a></li>
              { 
                this.props.user.permissions >= 5 ? 
                  <li><a onClick={e => {this.props.history.push('/dashboard/list-users')}}>Manage Users</a></li> 
                  : ''
              }
            </ul>
            <ul id="nav-mobile" className="right">
              <li><a onClick={e => {this.props.logout()}}>Logout</a></li>
            </ul>
          </div>
        </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js